import { Typography } from "@mui/material";
import { compareDesc, format, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { StyledSiniestralidad } from "../../../../../../../styled/Siniestros";

const JuntaMedicaCard = ({ data }) => {
  const [citaciones, setCitaciones] = useState(null);

  useEffect(() => {
    if (Array.isArray(data)) {
      const citasSorted = [...data].sort(function (a, b) {
        return compareDesc(parseISO(a.fecha), parseISO(b.fecha));
      });
      setCitaciones(citasSorted);
    }
  }, [data]);

  return (
    <>
      <div>
        {citaciones?.length ? (
          citaciones.map((cita) => (
            <StyledSiniestralidad.Card key={cita.fecha}>
              <div style={{ width: "99%" }}>
                <Typography variant="body2" style={{ color: "grey" }}>
                  {format(parseISO(cita.fecha), "dd/MM/yyyy HH:mm")}
                </Typography>
                {cita.nombre.split(" - ").map((campo) => {
                  return (
                    <Typography
                      variant="body2"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {campo}
                    </Typography>
                  );
                })}
              </div>
            </StyledSiniestralidad.Card>
          ))
        ) : (
          <StyledSiniestralidad.EmptyState variant="body2">
            No hay citas disponibles
          </StyledSiniestralidad.EmptyState>
        )}
      </div>
    </>
  );
};

export default JuntaMedicaCard;
